import React from 'react';

const Jcb = () => {
  return (
    <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="34" height="24" rx="4" fill="white" />
      <rect
        x="0.25"
        y="0.25"
        width="33.5"
        height="23.5"
        rx="3.75"
        stroke="black"
        strokeOpacity="0.15"
        strokeWidth="0.5"
      />
      <path
        d="M21.9819 11.9542C22.5131 11.9658 23.0474 11.9308 23.5765 11.9724C24.1124 12.0724 24.2416 12.8836 23.7655 13.1493C23.4407 13.3243 23.0548 13.2145 22.7026 13.2454H21.9819V11.9542ZM23.8837 10.4928C24.0018 10.9095 23.6001 11.2835 23.1989 11.2262H21.9819C21.9904 10.8333 21.9652 10.4068 21.9942 10.0346C22.4818 10.0484 22.9738 10.0066 23.4585 10.0564C23.6668 10.1088 23.8411 10.28 23.8837 10.4928ZM26.8126 4.31448C26.8353 5.11012 26.8159 5.94781 26.8224 6.75959C26.8209 10.06 26.8256 13.3603 26.8198 16.6609C26.7985 17.8978 25.7023 18.9726 24.4739 18.9972C23.2444 19.0022 22.0147 18.998 20.785 18.9994V14.0099C22.1248 14.003 23.4653 14.0239 24.8046 13.9994C25.4259 13.9604 26.1064 13.5505 26.1353 12.8668C26.2084 12.1801 25.5611 11.7051 24.9464 11.6301C24.7101 11.624 24.7171 11.5613 24.9464 11.5339C25.5326 11.4072 25.993 10.8004 25.8205 10.1928C25.6735 9.55368 24.9671 9.30631 24.3796 9.30754C23.1816 9.2994 21.9833 9.30641 20.7852 9.30404C20.793 8.37256 20.7691 7.44008 20.7981 6.50928C20.893 5.2947 22.0168 4.29307 23.2279 4.3148C24.423 4.31462 25.6178 4.31462 26.8126 4.31457V4.31448Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M7.24651 6.63505C7.2771 5.40011 8.37798 4.33415 9.60474 4.3161C10.8297 4.31233 12.0549 4.31556 13.2799 4.31446C13.2765 8.44633 13.2865 12.5786 13.2748 16.7103C13.2276 17.9302 12.1388 18.9759 10.9254 18.9975C9.69807 19.0019 8.47063 18.9981 7.24328 18.9993V13.8416C8.43544 14.1232 9.68562 14.2431 10.9018 14.0563C11.6288 13.9393 12.4242 13.5823 12.6704 12.8281C12.8515 12.1829 12.7495 11.504 12.7765 10.8418V9.30402H10.6717C10.6622 10.3211 10.6911 11.3399 10.6565 12.3557C10.5997 12.9801 9.9814 13.3768 9.39252 13.3556C8.66221 13.3633 7.215 12.8263 7.215 12.8263C7.21136 10.9208 7.23619 8.53443 7.24651 6.63524V6.63505Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M14.0648 9.92427C13.954 9.94778 14.0425 9.54689 14.0142 9.39482C14.0218 8.43328 13.9984 7.4707 14.0271 6.50985C14.1217 5.29014 15.2542 4.28601 16.4701 4.31456H20.0511C20.0477 8.44642 20.0577 12.5787 20.0461 16.7104C19.9988 17.9303 18.9099 18.9759 17.6964 18.9976C16.4691 19.0022 15.2416 18.9983 14.0142 18.9995V13.3485C14.8524 14.0363 15.9918 14.1433 17.0361 14.1452C17.8235 14.1449 18.6062 14.0235 19.3708 13.842V12.8067C18.5091 13.2361 17.4962 13.5089 16.5411 13.2622C15.8748 13.0963 15.3911 12.4524 15.4019 11.7648C15.3247 11.0497 15.7438 10.2947 16.4465 10.0822C17.319 9.80903 18.2699 10.0179 19.0877 10.373C19.2629 10.4648 19.4408 10.5786 19.3707 10.2857V9.47197C18.0029 9.14654 16.5473 9.0268 15.1732 9.38081C14.7754 9.49301 14.3879 9.66318 14.0648 9.92436V9.92427Z"
        fill="url(#paint2_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="20.7438"
          y1="11.343"
          x2="26.7843"
          y2="11.343"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58B03A" />
          <stop offset="1" stopColor="#55B330" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="7.11484"
          y1="11.7975"
          x2="13.1809"
          y2="11.7975"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0F6EB6" />
          <stop offset="1" stopColor="#006DBA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="14.0053"
          y1="11.4853"
          x2="20.05"
          y2="11.4853"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DE0D3D" />
          <stop offset="1" stopColor="#E30138" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Jcb;
